import { inject } from '@angular/core';
import { CanMatchFn, Route, Router, UrlSegment } from '@angular/router';
import { map, take } from 'rxjs/operators';
import { AppRoutes } from '@rx-applications/clientsite/shared/router/data-access';
import { AuthRoutes } from '@rx-applications/shared/auth/data-access';
import { addAbsolutePathPrefix } from '@rx-applications/shared/utils';
import { AuthApiFacade } from '@rx-applications/shared/auth/api';

export const GuestGuard: CanMatchFn = (route: Route, segments: UrlSegment[]) => {
  const authFacade: AuthApiFacade = inject(AuthApiFacade);
  const router: Router = inject(Router);

  return authFacade.isAuthenticated$.pipe(
    map((isAuthenticated: boolean) => {
      if (
        isAuthenticated &&
        !segments.some((segment) => segment.path === AuthRoutes.ResetPassword) &&
        !segments.some((segment) => segment.path === AuthRoutes.Verify) &&
        !segments.some((segment) => segment.path === AuthRoutes.SetupMFA) &&
        !segments.some((segment) => segment.path === AuthRoutes.ChangePassword)
      ) {
        router.navigate([addAbsolutePathPrefix(AppRoutes.Book)]);
        return false;
      }

      return true;
    }),
    take(1)
  );
};
